import * as React from "react";
import { Theme, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    "@media print": {
      display: "none"
    }
  }
}));

const NoPrint: React.FunctionComponent = (props) => {
  const classes = useStyles();
  return <div className={classes.root}>{props.children}</div>;
};

export default NoPrint;
